export const MIN_SEARCH_LENGTH = 2

export const PRICE_UPDATE_STATUS = {
  FRESH: 1,
  STALE: 2,
  OUTDATED: 3,
} as const
